function blockKeys(e: KeyboardEvent) {
	const active = document.activeElement;
	if (!active.classList.contains("dhx_alert__confirm-reject") && !active.classList.contains("dhx_alert__confirm-aply")) {
		e.preventDefault();
	}
}
export function blockScreen(css?: string) {
	const blocker = document.createElement("div");
	blocker.className = "dhx_alert__overlay " + (css || "");
	document.body.appendChild(blocker);
	document.addEventListener("keydown", blockKeys);
	return () => {
		document.body.removeChild(blocker);
		document.removeEventListener("keydown", blockKeys);
	};
}